import {createSlice} from '@reduxjs/toolkit';

const provider = createSlice({
    name        : 'provider',
    initialState: {
        displayLanguage     : localStorage.getItem('displayLanguage') || 'tr'
    },
    reducers: create => ({
        changeLanguage: create.reducer( (state, action) => {
            state.displayLanguage   = action.payload || 'tr'
        }),
        
    })
})

export default provider